import React, { useEffect, useState } from 'react';
import newLogo from '../Asset/SafeLog_Logo.png';
import notiRed from '../Asset/non-active-icon/notiRed.svg';
import noti from '../Asset/non-active-icon/noti.svg';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getUserInfo } from './functions/userInfo';
import {environment} from './functions/environment';

function Header() {
  let [isnew, setisNew] = useState(false);
  var name = '';
  var role = '';
  if (sessionStorage.getItem('userInfo')) {
    var UserInfo = getUserInfo();
    name = UserInfo.firstName + " " + UserInfo.lastName;
    role = UserInfo.userType
  } else {
    name = 'USER NAME'
  }
  const user = sessionStorage.getItem('userInfo') ? getUserInfo() : {};
  // call for customer type user, for check if user have new notification.
  useEffect(() => {
    if(user.userType === 'account_user')
    {
      getNotifications();
    }
  }, []);

  function getNotifications() {
    fetch(environment.baseUrl + 'getNotificationsByUser', {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.token
        }
    }).then((resp) => {
        resp.json().then((res) => {
            if (res.code == 200) {
                let arr = res.data.result.notifications;
                for(let i=0;i<arr.length;i++)
                {
                  if(!arr[i].isRead)
                  {
                    setisNew(true);
                    break;
                  }
                }
            }
            else {
                setisNew(false);
            }
        })
    })
}

  return (
    <>

      <Navbar fixed="top" className='header px-3'>
        {
          user.userType === 'admin' ?
            <Link to="/accounts" ><img src={newLogo} height="50" alt="" /></Link>
            :
            user.userType === 'account_user' ?
              <Link to="/my-equipment" ><img src={newLogo} height="50" alt="" /></Link>
              :
              user.userType === 'technician_user' ?
                <Link to="/preventive_maintenance" ><img src={newLogo} height="50" alt="" /></Link>
                : ""
        }



        <Nav className="ms-auto me-3">
          <Link to="/notification" className='nav-link position-relative'>
            {
              user.userType === 'account_user' ?
              isnew ?
                <img src={notiRed} alt="" />
                :
                <img src={noti} alt="" />
              :null
            }
          </Link>
          <Link to="/profile" className='nav-link'>
            <img src={user} alt="" />&nbsp; {name}
          </Link>
        </Nav>
      </Navbar>
    </>
  )
}

export default Header
